import { type Enum } from '@webapp/utils'

export const PaymentMethodManagementTypes = {
  EXTERNAL: 'external',
  MANAGED: 'managed',
} as const

export type PaymentMethodManagementType = Enum<
  typeof PaymentMethodManagementTypes
>
